import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function WhatsIncluded() {
  const tomos = [{
    num: '01',
    title: 'Bases de la Valoración Clínica',
    desc: 'Estructura clara para evaluar al paciente desde el primer contacto.'
  }, {
    num: '02',
    title: 'Procedimientos Fundamentales',
    desc: 'Técnica, criterio y seguridad en los procedimientos más frecuentes.'
  }, {
    num: '03',
    title: 'Enfermería Médico-Quirúrgica',
    desc: 'Organización del cuidado del paciente internado de principio a fin.'
  }, {
    num: '04',
    title: 'Urgencias y Situaciones Clínicas',
    desc: 'Detección de deterioro clínico y algoritmos de actuación rápida.'
  }, {
    num: '05',
    title: 'Farmacología Aplicada y Cálculos',
    desc: 'Administración segura, cálculo de dosis y medicación de alto riesgo.'
  }, {
    num: '06',
    title: 'Razonamiento Clínico y Casos',
    desc: 'Priorización, registros y 15 casos clínicos resueltos paso a paso.'
  }];
  return <section className="py-12 md:py-20 lg:py-24 bg-clinical-base" data-id="element-328">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-329">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14" data-id="element-330">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-mid mb-4" data-id="element-331">
            La biblioteca
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black text-clinical-deep mb-3 md:mb-4 leading-[1.05] uppercase" data-id="element-332">
            Qué incluye el Mega Pack
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg sm:text-xl md:text-2xl text-clinical-mid mb-4" data-id="element-333">
            6 tomos.{' '}
            <span className="accent-italic" data-id="element-334">Un sistema clínico completo.</span>
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-10 md:mb-12" data-id="element-335">
          {tomos.map((tomo, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="relative bg-white rounded-2xl md:rounded-3xl p-6 border border-clinical-line hover:border-clinical-mid/30 transition-all overflow-hidden flex flex-col h-full" data-id="element-336">
              <div className="absolute -top-4 -right-2 md:-top-6 md:-right-4 text-[90px] md:text-[110px] font-display font-black leading-none select-none pointer-events-none z-0 text-clinical-soft" data-id="element-337">
                {tomo.num}
              </div>

              <div className="relative z-10 flex-grow" data-id="element-338">
                <div className="inline-block px-3 py-1 rounded-full bg-clinical-soft text-clinical-deep text-xs font-bold mb-3 tracking-wide uppercase" data-id="element-339">
                  Tomo {tomo.num.replace('0', '')}
                </div>

                <h4 className="text-lg md:text-xl font-bold text-clinical-deep mb-3 pr-8 leading-tight uppercase" data-id="element-340">
                  {tomo.title}
                </h4>

                <p className="text-clinical-ink text-sm md:text-base leading-snug font-medium" data-id="element-341">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex justify-center px-4" data-id="element-342">
          <a href="#pricing" className="group inline-flex items-center justify-center gap-2 bg-clinical-cta hover:bg-clinical-ctaHover text-white font-semibold text-sm md:text-base px-7 md:px-9 py-4 rounded-full transition-all transform hover:scale-[1.02] shadow-[0_8px_24px_rgba(15,98,254,0.3)] w-full max-w-[360px] sm:w-auto uppercase tracking-wide" data-id="element-343">
            Quiero el Mega Pack completo
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform flex-shrink-0" data-id="element-344" />
          </a>
        </motion.div>
      </div>
    </section>;
}